// @flow
import {connect} from 'react-redux';
import ProductPageConfiguration from '../components/ProductPageConfiguration';
import {bindActionCreators} from 'redux';
import {actions as UiActions} from '../../../ui/duck';
import {actions as ProductPageActions} from '../../product-page/duck';
import type {RootState} from '../../..';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    productSetting: state.ui.storeProductSetting,
    isSavingProductSetting: state.ui.isSavingProductSetting,
    saveProductSettingSuccess: state.ui.saveProductSettingSuccess,
    saveProductSettingError: state.ui.saveProductSettingError,
    isFetchingProductPageSetting:
      state.productPage.isFetchingProductPageSetting,
    productPageSetting: state.productPage.productPageSetting,
    saveProductPageSettingSuccess:
      state.productPage.saveProductPageSettingSuccess,
    isSavingProductPageSetting: state.productPage.isSavingProductPageSetting,
    saveProductPageSettingError: state.productPage.saveProductPageSettingError,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators({...UiActions, ...ProductPageActions}, dispatch)
)(ProductPageConfiguration);
